<!-- nav -->
<nav class="navbar navbar-expand navbar-dark bg-dark" *ngIf="currentUser">
    <div class="navbar-nav">
        <a class="nav-item nav-link" (click)="gotoHOme()" >Home</a>
        <a class="nav-item nav-link">FAQ</a>
        <a class="nav-item nav-link" (click)="openQueryModal()" data-toggle="modal" data-target="#contactModal">Contact us</a>
        <a class="nav-item nav-link" (click)="logout()">Logout</a>
    </div>
</nav>

<div class="modal fade" id="contactModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header bg-theme">
          <h5 class="modal-title2 color-white" id="exampleModalLabel">Contact us</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup] = "QueryForm">
              <label class="form-label2 color-theme">Enter your query</label>
              <textarea class="form-input2" placeholder="Enter your query" [(ngModel)]="query" formControlName="query"
              id="query" [ngClass]="{'is-invalid': submitted && f.query.errors }" class="form-control form-input"></textarea>
              <div *ngIf="submitted && f.query.errors" class="invalid-feedback">
                <div *ngIf="f.query.errors.required">Query is required</div>
              </div>
          </form>
          <button class="btn bg-theme color-white mt-3" (click)="sendQuery($event)">Submit</button>
        </div>
      </div>
    </div>
  </div>


  <ng-template  #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
  let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
  
  <div class="modal-content">
    <div class="modal-header success-modal-header">
      <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
        <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
      </h5>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <h3 class="success-text">Success</h3>
          <p class="reset-hd2">Thanks for contacting us. Your query is registered with us.</p>
        </div>
      </div>
      <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
    </div>
  </div>
</ng-template>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>

<!-- main app container -->

<router-outlet></router-outlet>


<!-- credits -->